// extracted by mini-css-extract-plugin
var _1 = "LoginView-module__emailText--Mgc4_";
var _2 = "LoginView-module__terms--MUyRy";
export { _1 as "emailText", _2 as "terms" }
